export default __webpack_public_path__ + "static/media/european_union.4df516ff.svg";